/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-03-17",
    versionChannel: "nightly",
    buildDate: "2025-03-17T00:07:04.246Z",
    commitHash: "a300109b0be177ed58115c2d265370111788d32c",
};
